import React, { useState } from "react";
import { TextInput, TouchableOpacity, View, StyleSheet } from "react-native";
import { THEME_COLORS } from "../../themes";
import Text from "../CustomTextComponent";
import EditIcon from "@mui/icons-material/Edit";
import DoneAllRoundedIcon from "@mui/icons-material/DoneAllRounded";

interface ITextInputWithButtonProps {
  placeholder?: string;
  value: string;
  onSubmit?: (text) => void;
  label?: string;
}

const TextInputWithButton = (props: ITextInputWithButtonProps) => {
  const { placeholder, value, onSubmit, label } = props;
  const [text, setText] = useState(value);
  const [editable, setEditable] = useState(!!!value);

  return (
    <>
      <View style={{ flexDirection: "row", paddingHorizontal: 10 }}>
        {!!label ? (
          <Text fontSize={"medium"} type_of_six={"three_six"}>
            {label}
          </Text>
        ) : null}
        <TextInput
          style={{
            outline: "none",
            alignSelf: "flex-start",
            borderBottomWidth: 1,
            borderBottomColor: THEME_COLORS.grey1,
            marginLeft: 10,
            marginBottom: 10,
          }}
          placeholder={placeholder}
          editable={editable}
          value={text}
          onChangeText={(text) => setText(text)}
        />
      </View>
      {text && !editable ? (
        <TouchableOpacity
          style={[{ paddingLeft: 5 }, !!label ? styles.rightBorder : {}]}
          onPress={() => {
            setEditable(true);
          }}
        >
          <EditIcon style={{ paddingLeft: 5, color: "royalblue" }} />
        </TouchableOpacity>
      ) : (
        <TouchableOpacity
          disabled={!text}
          style={[{ paddingLeft: 5 }, !!label ? styles.rightBorder : {}]}
          onPress={() => {
            onSubmit(text);
            setEditable(false);
          }}
        >
          <DoneAllRoundedIcon style={{ paddingLeft: 5, color: text ? "green" : "grey" }} />
        </TouchableOpacity>
      )}
    </>
  );
};

const styles = StyleSheet.create({
  rightBorder: {
    borderRightWidth: 2,
    borderRightColor: THEME_COLORS.grey0,
    paddingRight: 5,
    maxHeight: 30,
  },
});

export default TextInputWithButton;
